import { render, staticRenderFns } from "./CLoadingManifestDetails.vue?vue&type=template&id=7aa35f68&scoped=true"
import script from "./CLoadingManifestDetails.vue?vue&type=script&lang=ts"
export * from "./CLoadingManifestDetails.vue?vue&type=script&lang=ts"
import style0 from "./CLoadingManifestDetails.vue?vue&type=style&index=0&id=7aa35f68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa35f68",
  null
  
)

export default component.exports